import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Information.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import useModal from '../../hooks/useModal';
import TooltipWrapper from '../Tooltip/TooltipWrapper';

import { TOP_NAVIGATION_MENU } from '../../constants';
import { isMobile } from '../../utils/util';

import { useGetNotificationsQuery } from '../../services/main';
import { selectUserEmail } from '../../features/authSlice';
import { selectMenu } from '../../features/infoSlice';
import { notificationsChanged } from '../../features/mainSlice';

export default function Information() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const email = useAppSelector(selectUserEmail);

  const {
    data: notifications,
    isLoading,
    refetch,
  } = useGetNotificationsQuery();

  const { toggleModal } = useModal();
  const [thumbnail, setThumbnail] = useState('');

  const buttonConfigs = [
    {
      key: 'notification',
      value: TOP_NAVIGATION_MENU.notification,
      tooltipContent: TOP_NAVIGATION_MENU.notification,
      className: cx(
        'btn',
        'notification',
        (notifications?.length || 0) > 0 && 'on'
      ),
    },
    {
      key: 'account',
      value: TOP_NAVIGATION_MENU.account,
      tooltipContent: TOP_NAVIGATION_MENU.account,
      className: cx('btn', 'account'),
    },
  ];

  const handleButtonClick = (key: string) => {
    toggleModal({ id: key, type: key });
  };

  useEffect(() => {
    setThumbnail(email ? email[0].toUpperCase() : '');
  }, [email]);

  useEffect(() => {
    refetch();
    dispatch(notificationsChanged(notifications));
  }, [notifications]);

  if ((isMobile && menu !== 'main') || isLoading || !notifications) return null;

  return (
    <div className={cx('util_area')}>
      <ul>
        {buttonConfigs.map((config) => (
          <li key={config.key}>
            <TooltipWrapper
              content={config.tooltipContent}
              onClick={() => handleButtonClick(config.key)}
            >
              {(tooltipProps) => (
                <button className={config.className} {...tooltipProps}>
                  <span className={cx(`svg_${config.key}`)}>
                    {config.key === 'account' && thumbnail ? (
                      <span>{thumbnail}</span>
                    ) : null}
                  </span>
                  <span className={cx('blind')}>{config.value}</span>
                </button>
              )}
            </TooltipWrapper>
          </li>
        ))}
      </ul>
    </div>
  );
}
